<template>
  <Container>
    <div class="wizard__sms">
      <v-layout align-center justify-center fill-height>
        <v-flex md10>
          <header class="text-xs-center">
            <h1 class="wizard__sms__title">
              <span>{{ $t(`${namespace}.share`) }}</span> {{ $t(`${namespace}.news`) }}
            </h1>
            <p class="wizard__sms__subtitle" v-html="$t(`${namespace}.subtitle`).replace('[COUNT]', employeesCount)" />
          </header>

          <div class="wizard__sms__content">
            <iframe
              src="https://www.youtube.com/embed/hE4zWv8O-Hc"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>

          <footer class="wizard__sms__footer">
            <Button
              v-if="hasRole('employee', 'ROLE_EMPLOYEE_WIZARD_PHONE_NUMBERS')"
              color="secondary"
              :disabled="isFetching"
              :loading="isFetching"
              gradient
              large
              @click="handleSendSms"
            >
              <span v-html="$t(`${namespace}.shareWithMyEmployees`)" />
            </Button>

            <div class="wizard__escape__container">
              <a
                :title="$t('Views.WizardPage.welcome.skipTutorial')"
                class="wizard__escape"
                @click="openAccessPlatformDialog"
              >
                {{ $t('Views.WizardPage.welcome.skipTutorial') }}
              </a>
            </div>
          </footer>
        </v-flex>
      </v-layout>
    </div>
  </Container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import { catchError } from 'corp-front-vue-commons/src/utils/functions'
import Container from 'components/pages/wizard/Container'

export default {
  name: 'SMS',
  props: {
    employeesCount: {
      type: Number,
      default: 0
    },
    employeesList: {
      type: Array
    }
  },
  components: {
    Container
  },
  computed: {
    ...mapState({
      globalCompany: ({ company }) => company.selectedCompany
    })
  },
  data () {
    return {
      namespace: 'Views.WizardPage.sms',
      isFetching: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleSetStep () {
      this.$emit('handleSetStep', {
        step: 'success'
      })
    },

    openAccessPlatformDialog () {
      this.$emit('openAccessPlatformDialog')
    },

    async handleSendSms () {
      this.$ga.event('botao', 'clicou', 'compartilhar_video')

      this.isFetching = true

      try {
        await this.$apiService.employee.sendSMS({
          companyId: this.globalCompany.id,
          phoneNumbers: this.employeesList
        })

        this.handleSetStep()
      } catch (error) {
        catchError(error)

        this.showAlert({
          type: 'error',
          message: this.$t(`${this.namespace}.errorMessage`)
        })
      }

      this.isFetching = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wizard__sms {
  padding: 0 15px;
}

.wizard__sms__title,
.wizard__sms__subtitle {
  font-family: $title-font;
}

.wizard__sms__title {
  color: var(--gray-7);
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
  margin-bottom: 10px;

  @media (min-width: 992px) {
    font-size: 36px;
  }

  span {
    color: $accent;
  }
}

.wizard__sms__subtitle {
  color: $gray-6;
  font-size: 16px;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 40px;

  strong {
    font-weight: 600;
  }
}

.wizard__sms__content {
  display: block;
  margin: 0 auto;
  max-width: 488px;

  iframe {
    min-height: 274px;
    width: 100%;
  }
}

.wizard__sms__footer {
  text-align: center;
  padding-top: 25px;
}
</style>
